<div class="contact-dialog-container">
    
    <div class="contact-dialog-content">
        <app-contact-information [contactFormConfig]="contactFormConfig" [contactInformation]="contactInformation" [action]="action" (onValueChange)="onValueChange.emit($event)"></app-contact-information>
    </div>

    <div class="dialog_actions">
        @if (action !== 'view') {
            <button type="button" class="secondary_button" (click)="close()">
                Close
            </button>

            <button type="button" class="primary_button" (click)="submit()">
                @if (action === 'edit') {
                    Update Contact
                } @else if (action === 'add' || action === 'clone') {
                    Add Contact
                }
            </button>
        }
    </div>
</div>